import React from "react"
import {useTranslation} from "react-i18next"
import {twMerge} from "tailwind-merge"

import {REACH_PERIODS, TReachPeriod} from "../period"

export const PeriodSelector: React.FC<{value: TReachPeriod; onChange: (next: TReachPeriod) => void}> = ({
  value,
  onChange,
}) => {
  const {t} = useTranslation()

  const labels: Record<TReachPeriod, string> = {
    "7d": t("ReachEngine_Period_7d"),
    "30d": t("ReachEngine_Period_30d"),
    lifetime: t("ReachEngine_Period_Lifetime"),
  }

  return (
    <div className={"flex gap-1 rounded-lg bg-cr-grey-5 p-1"}>
      {REACH_PERIODS.map(period => {
        const isActive = value === period
        return (
          <button
            key={period}
            type={"button"}
            aria-pressed={isActive}
            onClick={() => onChange(period)}
            className={twMerge(
              "rounded-md px-3 py-1 text-xs font-semibold transition-colors",
              isActive ? "bg-cr-blue text-white" : "text-cr-grey-50 hover:text-cr-grey-90"
            )}
          >
            {labels[period]}
          </button>
        )
      })}
    </div>
  )
}
